import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "src/shared/utilities/graphql/apolloClient";

import Footer from "../Footer";

const App = props => (
  <ApolloProvider client={apolloClient}>
    <Footer {...props} />
  </ApolloProvider>
);

App.propTypes = {};

export default App;
